export default "__VITE_ASSET__339141b8__"